// httpPorts — the Annotation BC slice: the three source-annotation write ports.

import { Result } from "@bilda/utils";
import type { SelectedSpan } from "../../components/SourceView/SourceView.js";
import type { AnnotationPorts } from "../ports/annotation.js";
import type { PortResult } from "../ports/result.js";
import { command } from "./shared.js";

const addSourceAnnotation = async (
    sourceId: string,
    blockId: string | undefined,
    text: string,
    span?: SelectedSpan,
): PortResult<void> => {
    const r = await command("placeAnnotation", {
        resourceId: sourceId,
        text,
        ...(blockId === undefined ? {} : { locator: blockId }),
        ...(span === undefined ? {} : { span }),
    });
    return Result.isErr(r) ? r : Result.ok(undefined);
};

// Mark a span with no required argument (`placeHighlight` command, the
// Highlight category). Same anchor-building shape as `addSourceAnnotation`
// above.
const placeHighlight = async (
    sourceId: string,
    blockId: string | undefined,
    note: string | undefined,
    span?: SelectedSpan,
): PortResult<void> => {
    const r = await command("placeHighlight", {
        resourceId: sourceId,
        ...(note === undefined ? {} : { note }),
        ...(blockId === undefined ? {} : { locator: blockId }),
        ...(span === undefined ? {} : { span }),
    });
    return Result.isErr(r) ? r : Result.ok(undefined);
};

const deleteSourceAnnotation = async (
    annotationId: string,
): PortResult<void> => {
    const r = await command("deleteAnnotation", { annotationId });
    return Result.isErr(r) ? r : Result.ok(undefined);
};

export const annotationHttp: AnnotationPorts = {
    addSourceAnnotation,
    placeHighlight,
    deleteSourceAnnotation,
};
